module.exports = __webpack_public_path__ + "img/Out Fishing main capsule.34355582.png";